export const MaxNumberOfStates = 20; // cannot be greater than 100 because DataGrid accepts maximum of 100 rows
